var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19020_31076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.672 10.6179L20.2255 3H18.6725L12.9822 9.61448L8.43729 3H3.19531L10.0681 13.0023L3.19531 20.9908H4.74836L10.7575 14.0056L15.5572 20.9908H20.7992L13.6717 10.6179H13.672ZM11.5449 13.0904L10.8486 12.0944L5.30794 4.16911H7.69333L12.1647 10.5651L12.861 11.5611L18.6733 19.8748H16.2879L11.5449 13.0908V13.0904Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19020_31076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6039,
    height: 18,
    fill: "white",
    transform: "translate(3.19531 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.391476e9cb539b31ad4f9728e91c3599.svg";
export { ForwardRef as ReactComponent };